import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import Breadcrumb from 'component/Breadcrumb'

import ContentHeader from 'component/utils/ContentHeader'
import * as gamaActions from 'action/gama'
import Form from 'component/gama/EditForm'

import { ToastContainer } from 'react-toastify'
import { renderToastSuccessMsg, renderToastWarn } from 'utils/ToastUtils'

class GamaEdit extends Component {
  state = {
    loadedGama: false,
  }

  async componentDidMount() {
    const { auth, fetchSections, savedGama } = this.props

    const params = {
      level: 2,
      sectionId: 0,
      subSectionId: 0,
      typeId: 0,
      subTypeId: 0,
      limit: 50,
      offset: 0,
      gamaRegionsBranchsParams:
        savedGama.gamaRegionsBranchsParams !== null &&
        savedGama.gamaRegionsBranchsParams !== undefined
          ? savedGama.gamaRegionsBranchsParams
          : null,
    }

    await fetchSections(auth.user.dsToken, params).then(() =>
      this.setState({ loadedGama: true })
    )
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('mobile.irc-configurations') },
      { title: translate('gama') },
    ]

    return <Breadcrumb steps={steps} />
  }

  handleSubmit = (args) => {
    const { auth, translate, fetchSectionsSuccess, updateGama } = this.props

    updateGama(auth.user.dsToken, { ...args }).then((resp) => {
      if (resp.cdStatus === 200) {
        renderToastSuccessMsg(translate('irc.gama.onSubmitSuccess'))
        fetchSectionsSuccess({ ...args, idGama: resp.data.idGama })
      } else {
        /* istanbul ignore else */
        if (resp.message && resp.message.dsMessage) {
          renderToastWarn(resp.message.dsMessage)
        }
      }
    })
  }

  render() {
    const { translate, auth, savedGama, error, fetchSections } = this.props
    const { loadedGama } = this.state

    return (
      <div className='irc'>
        <ContentHeader>{translate('mobile.irc-configurations')}</ContentHeader>

        {this.renderBreadcrumb()}

        {loadedGama && (
          <Form
            translate={translate}
            onSubmit={this.handleSubmit}
            records={''}
            auth={auth}
            savedGama={savedGama}
            initialValues={savedGama}
            error={error}
            fetchSections={fetchSections}
          />
        )}
        <ToastContainer newestOnTop />
      </div>
    )
  }
}

GamaEdit.propTypes = {
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  fetchSections: PropTypes.func.isRequired,
  fetchSectionsSuccess: PropTypes.func.isRequired,
  savedGama: PropTypes.object,
  error: PropTypes.object,
  updateGama: PropTypes.func.isRequired,
}

const mapStateToProps = /* istanbul ignore next */ ({ gamaReducer }) => ({
  savedGama: gamaReducer.get.record,
  error: gamaReducer.save.error,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(gamaActions, dispatch)

/* istanbul ignore next */
const GamaEditTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(GamaEdit)

/* istanbul ignore next */
export default connect(mapStateToProps, mapDispatchToProps)(GamaEditTranslated)

export { GamaEdit }
